"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Player {
    constructor(p) {
        this.idx = p.idx;
        this.name = p.name;
        this.id = p.id;
        this.isConnected = p.isConnected;
    }
    toJSON() {
        return {
            name: this.name,
            idx: this.idx,
            id: this.id,
            isConnected: this.isConnected,
        };
    }
}
exports.Player = Player;
// export class PlayerHandView {
//   hand: MaskedPlayerView
//   isMe: boolean
//   extraMysticalHand?: MaskedPlayerView
//   constructor(p: TPlayerHandViewState) {
//     // this.idx = p.idx
//     // this.name = p.name
//     this.hand = new MaskedPlayerView(p.hand)
//     // this.id = p.id
//     this.isMe = p.isMe
//     // this.isConnected = p.isConnected
//     if (!p.isMe) this.extraMysticalHand = new MaskedPlayerView(p.extraMysticalHand)
//   }
//   static meFromPlayer(hand: TMaskedCardState[]): PlayerHandView {
//     return new PlayerHandView({
//       hand,
//       isMe: true,
//     })
//   }
//   static otherFromPlayer(hand: MaskedCard[], extraMysticalHand: TMaskedCardState[]): PlayerHandView {
//     //
//     // hand.forEach((c, i) => {
//     //   c.possibleCards = demystifiedHand[i].possibleCards
//     // })
//     return new PlayerHandView({
//       hand,
//       isMe: false,
//       extraMysticalHand,
//     })
//   }
//   static outsiderFromPlayer(p: Player): PlayerHandView {
//     return new PlayerHandView({
//       ...p,
//       hand: [], // look, no hand(s)
//       isMe: false,
//       extraMysticalHand: [],
//     })
//   }
//   toJSON(): TPlayerHandViewState {
//     return this.isMe
//       ? {
//           // name: this.name,
//           hand: this.hand.toJSON(),
//           // idx: this.idx,
//           isMe: true,
//         }
//       : {
//           // name: this.name,
//           hand: this.hand.toJSON(),
//           // idx: this.idx,
//           isMe: false,
//           extraMysticalHand: (this.extraMysticalHand as MaskedPlayerView).toJSON(),
//         }
//   }
// }
//# sourceMappingURL=player.js.map